
/* eslint-disable */
export default function ieScrollFix() {
  // IE Only.
  if(navigator.userAgent.match(/Trident\/7\./)) {
    $('body').on("mousewheel", function () {
        // remove default behavior
        event.preventDefault(); 
  
        //scroll without smoothing
        var wheelDelta = event.wheelDelta;
        var currentScrollPosition = window.pageYOffset;
        window.scrollTo(0, currentScrollPosition - wheelDelta);
    });
  }
}
/* eslint-enable */
